export default {
      id: "ic-misc-salaire-usage",
      viewBox: "0 0 26 26",
      url: "../dist/images/" + "sprite.svg#ic-misc-salaire-usage",
      toString: function () {
        return this.url;
      }
    }